"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var rxjs_1 = require("rxjs");
var ThxLogoutDialogComponent = /** @class */ (function () {
    function ThxLogoutDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.reloadTime = 10;
        this.reloading = false;
    }
    ThxLogoutDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reloadSubscription = rxjs_1.interval(1000).subscribe(function () {
            if (_this.reloadTime > 0) {
                _this.reloadTime--;
                if (_this.reloadTime == 0) {
                    _this.reloading = true;
                    window.location.href = "/";
                }
            }
        });
    };
    ThxLogoutDialogComponent.prototype.ngOnDestroy = function () {
        this.reloadSubscription.unsubscribe();
    };
    ThxLogoutDialogComponent.prototype.closeAction = function () {
        this.reloading = true;
        window.location.href = "/";
    };
    return ThxLogoutDialogComponent;
}());
exports.ThxLogoutDialogComponent = ThxLogoutDialogComponent;
